export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00233.8ea67c70.png";